module.exports = __webpack_public_path__ + "static/media/item_48_3.a39bdc73.png";